export enum MobileDeviceUnmutedCheckState {
    Start = 'start',
    Play = 'play',
    Confirmation = 'confirmation',
    Done = 'done',
    Troubleshooting = 'troubleshooting',
}
